import Shops from './Shops'

export default Shops